module.exports = __webpack_public_path__ + "img/sentinel-icon-2.e26ff7c7.svg";